import { ComponentCO2 } from '@acies/domain';
import { ObservableCollection } from '@acies/observables';

/** The ListComponentCO2Model is responsible for the ComponentCO2 list view bindings, that shows all the ComponentCO2's the Account has. */
export default class ListComponentCO2Model {
	public co2Collection: ObservableCollection<ComponentCO2>;
	public selectAllCheckBoxEnabled: boolean;
	public globalSpinnerVisible: boolean;
	public firstSelectedItem: ComponentCO2 | null;
	public constructor() {
		this.co2Collection = new ObservableCollection();
		this.co2Collection.sortFunction = this.#sortByUpdated;
		this.selectAllCheckBoxEnabled = false;
		this.globalSpinnerVisible = true;
		this.firstSelectedItem = null;
	}

	/** Sort the Collection by the updatedAt property Descending. */
	#sortByUpdated(a: ComponentCO2, b: ComponentCO2): -1 | 1 {
		if (a.updatedAt > b.updatedAt) {
			return -1;
		}
		return 1;
	}
}
